import React from 'react';
import { motion } from 'framer-motion';

export default function Logo({ size = 48, animated = true }) {
  return (
    <motion.svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      initial={animated ? { opacity: 0, rotate: -10 } : false}
      animate={animated ? { opacity: 1, rotate: 0 } : false}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      {/* Cercle fond */}
      <motion.circle
        cx="50" cy="50" r="46"
        fill="none"
        stroke="url(#logoGradient)"
        strokeWidth="3"
        initial={animated ? { pathLength: 0 } : false}
        animate={animated ? { pathLength: 1 } : false}
        transition={{ duration: 1.2, ease: 'easeInOut' }}
      />

      {/* Plume */}
      <motion.path
        d="M50 20 C50 20, 35 45, 38 60 C40 68, 45 72, 50 80 C55 72, 60 68, 62 60 C65 45, 50 20, 50 20Z"
        fill="url(#logoGradient)"
        initial={animated ? { scale: 0, opacity: 0 } : false}
        animate={animated ? { scale: 1, opacity: 1 } : false}
        transition={{ delay: 0.4, duration: 0.5, type: 'spring' }}
        style={{ transformOrigin: '50px 50px' }}
      />

      {/* Tige de la plume */}
      <motion.line
        x1="50" y1="30" x2="50" y2="78"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        initial={animated ? { pathLength: 0 } : false}
        animate={animated ? { pathLength: 1 } : false}
        transition={{ delay: 0.8, duration: 0.4 }}
      />

      <defs>
        <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#c8956c" />
          <stop offset="100%" stopColor="#d4a574" />
        </linearGradient>
      </defs>
    </motion.svg>
  );
}